import { render } from "./ConfirmMFA.vue?vue&type=template&id=31f81bfa&scoped=true"
import script from "./ConfirmMFA.js?vue&type=script&lang=js"
export * from "./ConfirmMFA.js?vue&type=script&lang=js"

import "./ConfirmMFA.scss?vue&type=style&index=0&id=31f81bfa&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f81bfa"]])

export default __exports__